


















































































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxLoadPanel } from 'devextreme-vue';
import {
    DxChart,
    DxSeries,
    DxLegend,
    DxSize,
    DxCommonSeriesSettings,
    DxValueAxis,
    DxAdaptiveLayout,
    DxLabel,
    DxGrid,
    DxArgumentAxis,
    DxTick,
    DxCommonAxisSettings,
    DxFont,
    DxTooltip,
} from 'devextreme-vue/chart';

import {
    IResourcesData,
    IExpandedState,
    LocalizationKeys,
    Formatter,
    IMeasureFormattingOptions,
    ResourceRecord,
    ILoadingState,
} from '../classes';

interface IChartData {
    label: string;
    used: number;
    available: number;
    deficit: number;
}

@Component({
    components: {
        DxChart,
        DxSeries,
        DxLegend,
        DxSize,
        DxCommonSeriesSettings,
        DxValueAxis,
        DxAdaptiveLayout,
        DxLabel,
        DxGrid,
        DxArgumentAxis,
        DxTick,
        DxCommonAxisSettings,
        DxFont,
        DxTooltip,
        DxLoadPanel,
    },
})
export default class TechnicsChart extends Vue {
    private static readonly EXPANDED_HEIGHT: number = 182;
    private static readonly COLLAPSED_HEIGHT: number = 127;

    private static idCounter: number = 0;

    private static recordToChartData(record: ResourceRecord): IChartData {
        const label = record.operDayName.format({
            day: '2-digit',
        });
        let available;
        let used;
        let deficit;
        if (record.availableCount >= record.usedCount) {
            available = record.availableCount - record.usedCount;
            used = record.usedCount;
            deficit = 0;
        } else {
            available = 0;
            used = record.availableCount;
            deficit = record.usedCount - record.availableCount;
        }
        return {
            label,
            available,
            used,
            deficit,
        };
    }

    @Prop({ required: true })
    public technicsData?: IResourcesData & IExpandedState & ILoadingState;

    public LocalizationKeys = LocalizationKeys;

    private readonly id: number = ++TechnicsChart.idCounter;

    private readonly measureFormattingOptions: IMeasureFormattingOptions = {
        separator: '',
        numberFormattingOptions: {
            useGrouping: true,
            maximumFractionDigits: 2,
        },
        measures: [
            {
                power: 0,
                measure: '',
            },
        ],
    };

    private readonly totalSeriesName: string = 'Total';
    private readonly busySeriesName: string = 'Busy';
    private readonly deficitSeriesName: string = 'Deficit';

    private mounted(): void {
        if (!this.technicsData) {
            throw new Error('resourcesData is not set');
        }
    }

    private get isLoaded(): boolean {
        return this.technicsData!.isLoaded;
    }

    private get diagramHeight(): number {
        return this.technicsData!.isExpanded
            ? TechnicsChart.EXPANDED_HEIGHT
            : TechnicsChart.COLLAPSED_HEIGHT;
    }

    private get vehicleGroupedValues(): Map<string, IChartData[]> {
        const data = this.technicsData!.vehicles;
        const grouped = new Map<string, IChartData[]>();

        data?.forEach(record => {
            const resourceType = record.resourceType ?? '';
            if (!grouped.has(resourceType)) {
                const filterData =
                    resourceType === ''
                        ? data
                        : data.filter(x => x.resourceType === resourceType);
                grouped.set(
                    resourceType,
                    filterData.map(TechnicsChart.recordToChartData)
                );
            }
        });

        return grouped;
    }

    private get craneValues(): IChartData[] {
        const data = this.technicsData!.cranes;
        return data!.map(TechnicsChart.recordToChartData);
    }

    private customizeTooltip(pointInfo: {
        seriesName: string;
        originalValue: number;
        total: number;
    }): { html: string } {
        let value: number;

        if (pointInfo.seriesName === this.totalSeriesName) {
            value = pointInfo.total;
        } else if (pointInfo.seriesName === this.busySeriesName) {
            value = pointInfo.originalValue;
        } else if (pointInfo.seriesName === this.deficitSeriesName) {
            value = pointInfo.originalValue;
        } else {
            throw new Error(
                `Data Series '${pointInfo.seriesName}' is not supported`
            );
        }

        const strValue = Formatter.numberToMeasureString(
            value,
            this.measureFormattingOptions
        );
        const html = `<div class="s-tooltip"><span class="value">${strValue}</span></div>`;

        return { html };
    }
}
